import { Client } from 'nice-grpc-web';
import { GrpcClientFactoryType } from './types';
import {
  CreateOrganizationRequest,
  DeepPartial,
  GetOrganizationAvatar_Request,
  GetOrganizationAvatar_Response,
  GetOrganizationRequest,
  ListChildOrganizationsRequest,
  ListChildOrganizationsRequest_Response,
  Organization,
  OrganizationServiceDefinition,
  UpdateOrganizationRequest,
  ValidateOrganizationCreationTokenRequest,
  ValidateOrganizationCreationTokenRequest_Response,
} from '../customer_compiled/organization';

export default class OrganizationService {
  private static instance: OrganizationService;
  private readonly client: Client<typeof OrganizationServiceDefinition>;

  private constructor(grpcClientFactory: GrpcClientFactoryType) {
    this.client = grpcClientFactory<typeof OrganizationServiceDefinition>(OrganizationServiceDefinition);
  }

  static getInstance(grpcClientFactory: GrpcClientFactoryType) {
    if (!OrganizationService.instance) {
      OrganizationService.instance = new OrganizationService(grpcClientFactory);
    }

    return OrganizationService.instance;
  }

  getOrganization(payload: DeepPartial<GetOrganizationRequest> = {}): Promise<Organization> {
    const request = GetOrganizationRequest.fromPartial(payload);
    return this.client.get(request);
  }

  validateCreationToken(
    payload: DeepPartial<ValidateOrganizationCreationTokenRequest>,
  ): Promise<ValidateOrganizationCreationTokenRequest_Response> {
    const request = ValidateOrganizationCreationTokenRequest.fromPartial(payload);
    return this.client.validateCreationToken(request);
  }

  createOrganization(payload: DeepPartial<CreateOrganizationRequest>): Promise<Organization> {
    const request = CreateOrganizationRequest.fromPartial(payload);
    return this.client.create(request);
  }

  getOrganizationsAvatar(payload: DeepPartial<GetOrganizationAvatar_Request>): Promise<GetOrganizationAvatar_Response> {
    const request = GetOrganizationAvatar_Request.fromPartial(payload);
    return this.client.getAvatar(request);
  }

  listChildOrganizations(
    payload: DeepPartial<ListChildOrganizationsRequest>,
  ): Promise<ListChildOrganizationsRequest_Response> {
    const request = ListChildOrganizationsRequest.fromPartial(payload);
    return this.client.listChildOrganizations(request);
  }

  updateOrganization(payload: DeepPartial<UpdateOrganizationRequest>): Promise<Organization> {
    const request = UpdateOrganizationRequest.fromPartial(payload);
    return this.client.update(request);
  }
}
